/* eslint-disable no-throw-literal */
import {
  GET_SERVICE_ANSWER_EXIST,
  GET_SERVICE_ANSWER_CALL_EXIST,
  SERVICE_ANSWER_TARGET_LIST,
  SERVICE_ANSWER_NOANSWER_LIST,
  SERVICE_ANSWER_HISTORY_LIST,
  SERVICE_ANSWER_HISTORY_LIST_SUCCESS,
  SERVICE_ANSWER_HISTORY_LIST_FAILURE,
  SERVICE_ANSWER_FEEDBACK,
  SERVICE_ANSWER_FEEDBACK_SUCCESS,
  SERVICE_ANSWER_FEEDBACK_FAILURE,
  SERVICE_ANSWER_DETAIL_LIST,
  SERVICE_ANSWER_ANSWER_UPDATE,
  SERVICE_ANSWER_ALL_ANSWER_UPDATE
} from './mutation-types'

export default {
  state: {
    histories: undefined,
    feedback: undefined
  },
  getters: {
    serviceAnswerHistories: state => {
      return state.histories
    },
    serviceAnswerFeedback: state => {
      return state.feedback
    }
  },
  actions: {
    async [GET_SERVICE_ANSWER_EXIST] ({ dispatch }, params) {
      const res = await dispatch('apiGet', { url: '/asovi/service_answers/exist', data: params.data })
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        }
      }
      return res.data
    },
    async [GET_SERVICE_ANSWER_CALL_EXIST] ({ dispatch }, params) {
      const res = await dispatch('apiGet', { url: '/asovi/service_answers/call_exist', data: params.data })
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        }
      }
      return res.data
    },
    async [SERVICE_ANSWER_TARGET_LIST] ({ dispatch }, params) {
      console.log('SERVICE_ANSWER_TARGET_LIST')
      const data = params ? params.data : {}
      const res = await dispatch('apiGet', { url: '/asovi/service_answers/target_list', data: data })
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        }
      }
      return res.data
    },
    async [SERVICE_ANSWER_NOANSWER_LIST] ({ dispatch }) {
      console.log('SERVICE_ANSWER_NOANSWER_LIST')
      const res = await dispatch('apiGet', { url: '/asovi/service_answers/noanswer_list' })
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        }
      }
      return res.data
    },
    async [SERVICE_ANSWER_DETAIL_LIST] ({ dispatch }, params) {
      const res = await dispatch('apiGet', { url: '/asovi/service_answers/answer_detail_list', data: params.data })
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        }
      }
      return res.data
    },
    async [SERVICE_ANSWER_ANSWER_UPDATE] ({ dispatch }, params) {
      const res = await dispatch('apiPatch', { url: '/asovi/service_answers/save_answers', data: params.data })
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        }
      }
      return res.data
    },
    async [SERVICE_ANSWER_ALL_ANSWER_UPDATE] ({ dispatch }, params) {
      const res = await dispatch('apiPatch', { url: '/asovi/service_answers/save_answer_flag', data: {id: params.id} })
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        }
      }
      return res.data
    },
    async [SERVICE_ANSWER_HISTORY_LIST] ({ dispatch, commit }) {
      console.log('SERVICE_ANSWER_HISTORY_LIST')
      const res = await dispatch('apiGet', { url: '/asovi/service_answers/histories' })
      if (res.status !== 200 && res.status !== 204) {
        commit(SERVICE_ANSWER_HISTORY_LIST_FAILURE, res.data)
      }
      commit(SERVICE_ANSWER_HISTORY_LIST_SUCCESS, res.data)
    },
    async [SERVICE_ANSWER_FEEDBACK] ({ dispatch, commit }, params) {
      const data = params ? params.data : {}
      console.log('SERVICE_ANSWER_FEEDBACK')
      const res = await dispatch('apiGet', { url: '/asovi/service_answers/feedback', data: data })
      if (res.status !== 200 && res.status !== 204) {
        commit(SERVICE_ANSWER_FEEDBACK_FAILURE, res.data)
      }
      commit(SERVICE_ANSWER_FEEDBACK_SUCCESS, res.data)
    }
  },
  mutations: {
    [SERVICE_ANSWER_HISTORY_LIST_FAILURE] (state, data) {
      console.log('SERVICE_ANSWER_HISTORY_LIST_FAILURE')
    },
    [SERVICE_ANSWER_HISTORY_LIST_SUCCESS] (state, data) {
      console.log('SERVICE_ANSWER_HISTORY_LIST_SUCCESS')
      state.histories = data
    },
    [SERVICE_ANSWER_FEEDBACK_FAILURE] (state, data) {
      console.log('SERVICE_ANSWER_FEEDBACK_FAILURE')
    },
    [SERVICE_ANSWER_FEEDBACK_SUCCESS] (state, data) {
      console.log('SERVICE_ANSWER_FEEDBACK_SUCCESS')
      state.feedback = data
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/service-answer.js